<script lang="ts">
	import { Icon } from '@repo/commons/components'
	import type { Tool } from '@repo/commons/models'
	import { scaleFade } from '@repo/commons/utils'

	interface Props {
		tools: Tool[]
		show?: boolean
		fixed?: boolean
		className?: string
	}

	let { tools = [], show = true, fixed = false, className = '' }: Props = $props()

	function handleToolClick(tool: Tool) {
		if (tool.disabled) {
			return
		}

		if (tool.callback && typeof tool.callback === 'function') {
			tool.callback()
		}
	}
</script>

{#if show}
	<div class={`toolbelt-container ${className}`} class:toolbelt-container--fixed={fixed}>
		<div class="toolbelt" transition:scaleFade={{ duration: 300, baseScale: 0.95 }}>
			{#each tools as tool (tool.id)}
				{#if tool.type === 'text'}
					<span class="toolbelt-text">
						{tool.label}
					</span>
				{:else}
					<button
						type="button"
						class="tool-button"
						class:tool-button--stepper={tool.type === 'stepper'}
						class:tool-button--duplicate={tool.type === 'duplicate'}
						class:tool-button--delete={tool.type === 'delete'}
						class:tool-button--default={!tool.type ||
							(tool.type !== 'duplicate' && tool.type !== 'delete')}
						class:tool-button--icon-only={tool.icon && !tool.label}
						onclick={() => handleToolClick(tool)}
						disabled={tool.disabled}
						aria-label={tool.label}
					>
						{#if tool.icon}
							<Icon name={tool.icon} size="sm" />
						{/if}
						{#if tool.label}
							<span>{tool.label}</span>
						{/if}
					</button>
				{/if}
			{/each}
		</div>
	</div>
{/if}

<style>
	.toolbelt-container {
		@apply inline-block;
	}

	.toolbelt-container--fixed {
		@apply fixed bottom-6 left-1/2 z-50;
		transform: translateX(-50%);
	}

	.toolbelt {
		@apply inline-flex items-center min-h-9 bg-[#042126] rounded-lg py-1 px-1.5 gap-2;
	}

	.tool-button {
		@apply flex py-1 px-2 items-center justify-center gap-2 rounded-md text-sm font-normal min-h-7
		transition-colors duration-200 hover:bg-slate-700
		focus:outline-none focus:ring-2 focus:ring-slate-500
		focus:ring-offset-2 focus:ring-offset-slate-800;
	}

	.tool-button--icon-only {
		@apply px-2;
	}

	.tool-button--duplicate {
		@apply text-[#A3DAFF];
	}

	.tool-button--delete {
		@apply text-[#FF9CA8];
	}

	.tool-button--default {
		@apply text-[#A3DAFF];
	}

	.tool-button--stepper {
		@apply text-[#FFFFFF99];
	}

	.tool-button:disabled {
		@apply opacity-50 cursor-not-allowed hover:bg-transparent;
	}

	.toolbelt-text {
		@apply text-sm text-[#FFFFFFC7];
	}
</style>
